/**
 * Partner directory — stubbed data.
 *
 * Schema is shared across the four categories so a single `PartnersTable`
 * component can render any of them. Replace the rows below with real partners
 * when ready; the page picks up changes automatically.
 *
 * Row shape:
 *   {
 *     id: string,        // slug, unique within category
 *     name: string,      // partner display name
 *     region: string,    // country or macro region (drives Region filter)
 *     type: string,      // category-specific sub-type (drives Type filter)
 *     founded: number,   // year founded (sortable)
 *     status: string,    // 'Active' | 'Onboarding' | 'Pending' (drives Status filter)
 *     website: string,   // external URL ('' if not public yet)
 *     description: string,
 *   }
 *
 * Listed-company rows (`partnersTablePreset: 'ticker'`, used by Mining + Pharma)
 * add: ticker, quoteChange, marketCap, marketCapSort (number for
 * sorting; -1 = Private, -2 = Acquired).
 */

import aiDirectory from './ai-directory.json';
import bullionDirectory from './bullion-directory.json';
import miningDirectory from './mining-directory.json';
import pharmaDirectory from './pharma-directory.json';

export const PARTNER_CATEGORIES = [
  {
    id: 'mining',
    label: 'Crypto Mining',
    tagline: 'Public miners, ASIC manufacturers, hosting providers, and major pools.',
    iconName: 'Cpu',
    partnersTablePreset: 'ticker',
    partners: miningDirectory,
  },
  {
    id: 'bullion',
    label: 'Bullion Trade',
    tagline: 'Refineries, mints, vaults, dealers, and metals-trading desks.',
    iconName: 'Coins',
    partnersTablePreset: 'ticker',
    partners: bullionDirectory,
  },
  {
    id: 'pharma',
    label: 'Pharma Companies',
    tagline: 'Drug developers, CDMOs, and life-science research operators.',
    iconName: 'Pill',
    partnersTablePreset: 'ticker',
    partners: pharmaDirectory,
  },
  {
    id: 'ai',
    label: 'AI Infrastructure',
    tagline: 'Silicon, hyperscale clouds, GPU operators, and data-center REITs.',
    iconName: 'Server',
    partnersTablePreset: 'ticker',
    partners: aiDirectory,
  },
];

/**
 * Look up a category by id. Returns undefined when the id doesn't match.
 */
export function getPartnerCategoryById(id) {
  return PARTNER_CATEGORIES.find((c) => c.id === id);
}
